import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { ArticleComponentData } from '../../../types/material.interface';
import { MapLibreMapComponent, MapLibreConfig } from '../maplibre-map/maplibre-map.component';
import { MaterialsPillsComponent } from '../materials-pills/materials-pills.component';
import { RecyclingPointCardComponent } from '../recycling-point-card/recycling-point-card.component';
import { MarkdownViewerComponent } from '../markdown-viewer/markdown-viewer.component';
import { SwNavigatorService } from '../../../shared/services/sw-navigator.service';
import { PlatformService } from '../../../shared/services/platform.service';

@Component({
  selector: 'app-article',
  standalone: true,
  imports: [
    CommonModule, 
    TranslatePipe,
    MapLibreMapComponent, 
    MaterialsPillsComponent, 
    RecyclingPointCardComponent,
    MarkdownViewerComponent
  ],
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  @Input() content: ArticleComponentData[] = [];
  @Input() editable: boolean = false;
  @Input() materialId: string | null = null;
  @Output() contentUpdate = new EventEmitter<ArticleComponentData[]>();
  @Output() buttonClick = new EventEmitter<{ action?: string; index: number }>();

  private swnav = inject(SwNavigatorService);
  private platform = inject(PlatformService);

  ngOnInit() {
    // Skip history state check during SSR
    if (!this.platform.isBrowser) return;
    
    // Check if returning from edit-markdown page with updated content
    const state = history.state;
    if (state?.updatedContent !== undefined && state?.contentIndex !== undefined) {
      const index = state.contentIndex;
      const updatedContent = [...this.content];
      updatedContent[index] = {
        ...updatedContent[index],
        data: state.updatedContent
      };
      this.content = updatedContent;
      this.contentUpdate.emit(updatedContent);
      
      // Clear the history state
      history.replaceState({}, document.title);
    }
  }

  getMapConfig(data: any): MapLibreConfig {
    return {
      apiKey: '8FiiAgen2GFv9bVz2wMY', // Default key
      zoom: data?.zoom || 13,
      point: data?.point
    };
  }

  startEditing(index: number, currentContent: string) {
    // Navigate to edit-markdown page with the content
    console.log('Article - startEditing called with:', {
      index,
      contentLength: currentContent.length,
      materialId: this.materialId,
      contentPreview: currentContent.substring(0, 100)
    });
    
    this.swnav.navigateObj({
      path: '/edit-markdown',
      state: {
        content: currentContent,
        materialId: this.materialId,
        contentIndex: index
      }
    });
  }
}
